import { render, staticRenderFns } from "./AddonDialogForm.vue?vue&type=template&id=724ab02e&scoped=true"
import script from "./AddonDialogForm.vue?vue&type=script&lang=js"
export * from "./AddonDialogForm.vue?vue&type=script&lang=js"
import style0 from "./AddonDialogForm.vue?vue&type=style&index=0&id=724ab02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ab02e",
  null
  
)

export default component.exports